import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_crvCooperationLogoWhite = _resolveComponent("crvCooperationLogoWhite")!
  const _component_crv_app_locale_switcher = _resolveComponent("crv-app-locale-switcher")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    color: "base-brand-blue",
    class: "d-flex justify-end"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_crvCooperationLogoWhite, {
        class: "crv-cooperation-logo-white pa-2 me-auto",
        onClick: _ctx.goBackHome
      }, null, 8, ["onClick"]),
      _createVNode(_component_crv_app_locale_switcher, {
        "model-value": _ctx.$i18n.locale,
        "tooltip-text": _ctx.$t('localeSwitcher.tooltip'),
        locales: _ctx.locales,
        "onUpdate:modelValue": _ctx.handleSelectLocale
      }, null, 8, ["model-value", "tooltip-text", "locales", "onUpdate:modelValue"])
    ]),
    _: 1
  }))
}